import PropTypes from 'prop-types';
import MapView from '../../map/core/MapView';
import MapGeofence from '../../map/MapGeofence';
import MapCamera from '../../map/MapCamera';

const ReportMapContent = ({
  children,
  showGeofence,
  camera,
  cameraProps,
}) => (
  <>
    <MapView>
      {showGeofence && <MapGeofence />}
      {children}
    </MapView>
    {camera && <MapCamera {...cameraProps} />}
  </>
);

ReportMapContent.propTypes = {
  children: PropTypes.node,
  showGeofence: PropTypes.bool,
  camera: PropTypes.bool,
  cameraProps: PropTypes.object,
};

ReportMapContent.defaultProps = {
  children: null,
  showGeofence: true,
  camera: false,
  cameraProps: {},
};

export default ReportMapContent;
